import api from '../../interceptors/axiosConfig';
import { ApiError } from '../../utils/apiUtils';
import type { AuthApiRequestOptions } from '../../types/services/auth';

export const authApiRequest = async (
  url: string,
  options: AuthApiRequestOptions = {},
): Promise<any> => {
  const {
    method = 'GET',
    headers = {},
    body,
  } = options;

  const requestHeaders: Record<string, string> = {
    'Content-Type': 'application/json',
    ...headers,
  };

  try {
    const response = await api({
      method,
      url,
      headers: requestHeaders,
      data: body,
    });

    return response.data;
  } catch (error: any) {
    if (error.response) {
      const errorData = error.response.data || {};
      console.error('Auth API request failed:', error.response.status, errorData);
      throw new ApiError(
        errorData.detail || `Request failed: ${error.response.statusText}`,
        error.response.status,
        errorData,
      );
    }

    if (error.request) {
      console.error('Auth API request error:', error);
      throw new ApiError('Network error', 0);
    }

    console.error('Auth API request error:', error);
    throw new ApiError(error.message || 'An unexpected error occurred', 0);
  }
};

